import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Chapters } from "@/components/Chapters";
import { LeadCapture } from "@/components/LeadCapture";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const [interest, setInterest] = useState(null);

  const handleInterest = (key) => {
    setInterest(key);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero onExplore={() => document.getElementById("chapter-land")?.scrollIntoView({ behavior: "smooth" })} />
      <EditorialMarquee />
      <Chapters onInterest={handleInterest} />
      <LeadCapture interest={interest} />
      <Footer />
    </main>
  );
}
